import { getEnumFromValueType } from '@semios/app-platform-values-helpers-and-types'
import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { translate } from 'i18n/i18n'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import { unitConverter } from 'utils/unitConverter/unitConverter'

const getIrrigationVolumeDurationLabel = (valueType: string) => {
  const emitterType = getEnumFromValueType(valueType)
  const emitterLabel = emitterType ? mapApiEmitterTypeToLabel(emitterType) : valueType

  if (valueType.startsWith('irrigationPlanned')) {
    return translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: translate.phrases.banyanApp('Irrigation Scheduled'),
      labelB: emitterLabel,
    })
  } else {
    return translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: translate.phrases.banyanApp('Irrigation Applied'),
      labelB: emitterLabel,
    })
  }
}

const irrigationVolumeDurationRenderer = (valueType: string) => {
  const emitterType = getEnumFromValueType(valueType)
  const emitterLabel = emitterType ? mapApiEmitterTypeToLabel(emitterType) : valueType

  const baseLabel = twoItemLabel([
    twoItemLabel([translate.phrases.banyanApp('Irrigation Activity'), emitterLabel]),
    valueType.startsWith('irrigationPlanned')
      ? translate.phrases.banyanApp('Scheduled')
      : translate.phrases.banyanApp('Applied'),
  ])

  const volumeLabel = twoItemLabel([baseLabel, unitConverter.irrigationActivity().suffix()])
  const durationLabel = twoItemLabel([baseLabel, translate.phrases.banyanApp('Minutes')])

  return (
    value: {
      duration: number | null
      volume_mm?: number | null
    } | null,
  ) => {
    const volume_mm = value === null ? null : value.volume_mm
    const duration = value === null ? null : value.duration

    return [
      {
        id: 'volume',
        value: unitConverter.irrigationActivity(volume_mm).valueAsString(),
        label: volumeLabel,
      },
      {
        id: 'duration',
        value: translate.measurements.millimeters.value(duration === null ? null : duration / 60000, 0),
        label: durationLabel,
      },
    ]
  }
}

export const irrigationVolumeDuration = {
  label: getIrrigationVolumeDurationLabel,
  irrigationZone: ({ valueType }: { valueType: string }) => irrigationVolumeDurationRenderer(valueType),
  point: ({ valueType }: { valueType: string }) => irrigationVolumeDurationRenderer(valueType),
}
